/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetReceivableQueryResponse, GetReceivablePathParams, GetReceivable400, GetReceivable401, GetReceivable403, GetReceivable404, GetReceivable409, GetReceivable500 } from "../../types/financialHubController/GetReceivable.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getReceivable } from "../../client/financialHubController/getReceivable.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getReceivableQueryKey = (organizationId: GetReceivablePathParams["organizationId"] | undefined, receivableId: GetReceivablePathParams["receivableId"] | undefined) => [{ url: '/api/organizations/:organizationId/financial/receivables/:receivableId', params: {organizationId:organizationId,receivableId:receivableId} }] as const

export type GetReceivableQueryKey = ReturnType<typeof getReceivableQueryKey>

export function getReceivableQueryOptions(organizationId: GetReceivablePathParams["organizationId"] | undefined, receivableId: GetReceivablePathParams["receivableId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getReceivableQueryKey(organizationId, receivableId)
        return queryOptions<GetReceivableQueryResponse, ResponseErrorConfig<GetReceivable400 | GetReceivable401 | GetReceivable403 | GetReceivable404 | GetReceivable409 | GetReceivable500>, GetReceivableQueryResponse, typeof queryKey>({
         enabled: !!(organizationId && receivableId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getReceivable(organizationId!, receivableId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get a receivable with its receipts
 * {@link /api/organizations/:organizationId/financial/receivables/:receivableId}
 */
export function useGetReceivable<TData = GetReceivableQueryResponse, TQueryData = GetReceivableQueryResponse, TQueryKey extends QueryKey = GetReceivableQueryKey>(organizationId: GetReceivablePathParams["organizationId"] | undefined, receivableId: GetReceivablePathParams["receivableId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<GetReceivableQueryResponse, ResponseErrorConfig<GetReceivable400 | GetReceivable401 | GetReceivable403 | GetReceivable404 | GetReceivable409 | GetReceivable500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getReceivableQueryKey(organizationId, receivableId)
         

         const query = useQuery({
          ...getReceivableQueryOptions(organizationId, receivableId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetReceivable400 | GetReceivable401 | GetReceivable403 | GetReceivable404 | GetReceivable409 | GetReceivable500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}